module.exports = __webpack_public_path__ + "img/top2.25ac81da.png";